// Guardian AI HR Manager Service Protocol Definitions
// HR Manager CRUD, Expert management, slot limits, and onboarding
//
// Version: v1
// Purpose: High-Trust Cybersecurity Marketplace - HR Manager operations

// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none,json_types=true"
// @generated from file guardianai/v1/hr/hr_manager.proto (package guardianai.v1.hr, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file guardianai/v1/hr/hr_manager.proto.
 */
export const file_guardianai_v1_hr_hr_manager: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * @generated from message guardianai.v1.hr.HrManager
 */
export type HrManager = Message<"guardianai.v1.hr.HrManager"> & {
  /**
   * @generated from field: string hr_manager_id = 1;
   */
  hrManagerId: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId: string;

  /**
   * @generated from field: string email = 3;
   */
  email: string;

  /**
   * @generated from field: string full_name = 4;
   */
  fullName: string;

  /**
   * PENDING, ACTIVE, SUSPENDED
   *
   * @generated from field: string status = 5;
   */
  status: string;

  /**
   * @generated from field: int32 max_expert_slots = 6;
   */
  maxExpertSlots: number;

  /**
   * @generated from field: int32 used_expert_slots = 7;
   */
  usedExpertSlots: number;

  /**
   * Percentage of expert earnings (e.g., 0.05 = 5%)
   *
   * @generated from field: double commission_rate = 8;
   */
  commissionRate: number;

  /**
   * Admin who created this HR Manager
   *
   * @generated from field: string created_by_user_id = 9;
   */
  createdByUserId: string;

  /**
   * Who suspended (if suspended)
   *
   * @generated from field: string suspended_by_user_id = 10;
   */
  suspendedByUserId: string;

  /**
   * @generated from field: string suspension_reason = 11;
   */
  suspensionReason: string;

  /**
   * @generated from field: int64 created_at = 12;
   */
  createdAt: bigint;

  /**
   * @generated from field: int64 updated_at = 13;
   */
  updatedAt: bigint;
};

/**
 * @generated from message guardianai.v1.hr.HrManager
 */
export type HrManagerJson = {
  /**
   * @generated from field: string hr_manager_id = 1;
   */
  hrManagerId?: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId?: string;

  /**
   * @generated from field: string email = 3;
   */
  email?: string;

  /**
   * @generated from field: string full_name = 4;
   */
  fullName?: string;

  /**
   * PENDING, ACTIVE, SUSPENDED
   *
   * @generated from field: string status = 5;
   */
  status?: string;

  /**
   * @generated from field: int32 max_expert_slots = 6;
   */
  maxExpertSlots?: number;

  /**
   * @generated from field: int32 used_expert_slots = 7;
   */
  usedExpertSlots?: number;

  /**
   * Percentage of expert earnings (e.g., 0.05 = 5%)
   *
   * @generated from field: double commission_rate = 8;
   */
  commissionRate?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * Admin who created this HR Manager
   *
   * @generated from field: string created_by_user_id = 9;
   */
  createdByUserId?: string;

  /**
   * Who suspended (if suspended)
   *
   * @generated from field: string suspended_by_user_id = 10;
   */
  suspendedByUserId?: string;

  /**
   * @generated from field: string suspension_reason = 11;
   */
  suspensionReason?: string;

  /**
   * @generated from field: int64 created_at = 12;
   */
  createdAt?: string;

  /**
   * @generated from field: int64 updated_at = 13;
   */
  updatedAt?: string;
};

/**
 * Describes the message guardianai.v1.hr.HrManager.
 * Use `create(HrManagerSchema)` to create a new message.
 */
export const HrManagerSchema: GenMessage<HrManager, {jsonType: HrManagerJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_hr_hr_manager, 0);

/**
 * @generated from message guardianai.v1.hr.CreateHrManagerRequest
 */
export type CreateHrManagerRequest = Message<"guardianai.v1.hr.CreateHrManagerRequest"> & {
  /**
   * @generated from field: string email = 1;
   */
  email: string;

  /**
   * @generated from field: string full_name = 2;
   */
  fullName: string;

  /**
   * Default: 10
   *
   * @generated from field: int32 max_expert_slots = 3;
   */
  maxExpertSlots: number;

  /**
   * Default: 0.05 (5%)
   *
   * @generated from field: double commission_rate = 4;
   */
  commissionRate: number;

  /**
   * @generated from field: string created_by_admin_id = 5;
   */
  createdByAdminId: string;
};

/**
 * @generated from message guardianai.v1.hr.CreateHrManagerRequest
 */
export type CreateHrManagerRequestJson = {
  /**
   * @generated from field: string email = 1;
   */
  email?: string;

  /**
   * @generated from field: string full_name = 2;
   */
  fullName?: string;

  /**
   * Default: 10
   *
   * @generated from field: int32 max_expert_slots = 3;
   */
  maxExpertSlots?: number;

  /**
   * Default: 0.05 (5%)
   *
   * @generated from field: double commission_rate = 4;
   */
  commissionRate?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: string created_by_admin_id = 5;
   */
  createdByAdminId?: string;
};

/**
 * Describes the message guardianai.v1.hr.CreateHrManagerRequest.
 * Use `create(CreateHrManagerRequestSchema)` to create a new message.
 */
export const CreateHrManagerRequestSchema: GenMessage<CreateHrManagerRequest, {jsonType: CreateHrManagerRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_hr_hr_manager, 1);

/**
 * @generated from message guardianai.v1.hr.HrManagerResponse
 */
export type HrManagerResponse = Message<"guardianai.v1.hr.HrManagerResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message: string;

  /**
   * @generated from field: guardianai.v1.hr.HrManager hr_manager = 3;
   */
  hrManager?: HrManager;
};

/**
 * @generated from message guardianai.v1.hr.HrManagerResponse
 */
export type HrManagerResponseJson = {
  /**
   * @generated from field: bool success = 1;
   */
  success?: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message?: string;

  /**
   * @generated from field: guardianai.v1.hr.HrManager hr_manager = 3;
   */
  hrManager?: HrManagerJson;
};

/**
 * Describes the message guardianai.v1.hr.HrManagerResponse.
 * Use `create(HrManagerResponseSchema)` to create a new message.
 */
export const HrManagerResponseSchema: GenMessage<HrManagerResponse, {jsonType: HrManagerResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_hr_hr_manager, 2);

/**
 * @generated from message guardianai.v1.hr.GetHrManagerRequest
 */
export type GetHrManagerRequest = Message<"guardianai.v1.hr.GetHrManagerRequest"> & {
  /**
   * @generated from field: string hr_manager_id = 1;
   */
  hrManagerId: string;
};

/**
 * @generated from message guardianai.v1.hr.GetHrManagerRequest
 */
export type GetHrManagerRequestJson = {
  /**
   * @generated from field: string hr_manager_id = 1;
   */
  hrManagerId?: string;
};

/**
 * Describes the message guardianai.v1.hr.GetHrManagerRequest.
 * Use `create(GetHrManagerRequestSchema)` to create a new message.
 */
export const GetHrManagerRequestSchema: GenMessage<GetHrManagerRequest, {jsonType: GetHrManagerRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_hr_hr_manager, 3);

/**
 * @generated from message guardianai.v1.hr.ListHrManagersRequest
 */
export type ListHrManagersRequest = Message<"guardianai.v1.hr.ListHrManagersRequest"> & {
  /**
   * PENDING, ACTIVE, SUSPENDED, or empty for all
   *
   * @generated from field: string status_filter = 1;
   */
  statusFilter: string;

  /**
   * @generated from field: int32 page = 2;
   */
  page: number;

  /**
   * @generated from field: int32 limit = 3;
   */
  limit: number;
};

/**
 * @generated from message guardianai.v1.hr.ListHrManagersRequest
 */
export type ListHrManagersRequestJson = {
  /**
   * PENDING, ACTIVE, SUSPENDED, or empty for all
   *
   * @generated from field: string status_filter = 1;
   */
  statusFilter?: string;

  /**
   * @generated from field: int32 page = 2;
   */
  page?: number;

  /**
   * @generated from field: int32 limit = 3;
   */
  limit?: number;
};

/**
 * Describes the message guardianai.v1.hr.ListHrManagersRequest.
 * Use `create(ListHrManagersRequestSchema)` to create a new message.
 */
export const ListHrManagersRequestSchema: GenMessage<ListHrManagersRequest, {jsonType: ListHrManagersRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_hr_hr_manager, 4);

/**
 * @generated from message guardianai.v1.hr.ListHrManagersResponse
 */
export type ListHrManagersResponse = Message<"guardianai.v1.hr.ListHrManagersResponse"> & {
  /**
   * @generated from field: repeated guardianai.v1.hr.HrManager hr_managers = 1;
   */
  hrManagers: HrManager[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;

  /**
   * @generated from field: int32 page = 3;
   */
  page: number;

  /**
   * @generated from field: int32 limit = 4;
   */
  limit: number;
};

/**
 * @generated from message guardianai.v1.hr.ListHrManagersResponse
 */
export type ListHrManagersResponseJson = {
  /**
   * @generated from field: repeated guardianai.v1.hr.HrManager hr_managers = 1;
   */
  hrManagers?: HrManagerJson[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount?: number;

  /**
   * @generated from field: int32 page = 3;
   */
  page?: number;

  /**
   * @generated from field: int32 limit = 4;
   */
  limit?: number;
};

/**
 * Describes the message guardianai.v1.hr.ListHrManagersResponse.
 * Use `create(ListHrManagersResponseSchema)` to create a new message.
 */
export const ListHrManagersResponseSchema: GenMessage<ListHrManagersResponse, {jsonType: ListHrManagersResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_hr_hr_manager, 5);

/**
 * @generated from message guardianai.v1.hr.UpdateHrManagerRequest
 */
export type UpdateHrManagerRequest = Message<"guardianai.v1.hr.UpdateHrManagerRequest"> & {
  /**
   * @generated from field: string hr_manager_id = 1;
   */
  hrManagerId: string;

  /**
   * @generated from field: string full_name = 2;
   */
  fullName: string;

  /**
   * @generated from field: int32 max_expert_slots = 3;
   */
  maxExpertSlots: number;

  /**
   * @generated from field: double commission_rate = 4;
   */
  commissionRate: number;
};

/**
 * @generated from message guardianai.v1.hr.UpdateHrManagerRequest
 */
export type UpdateHrManagerRequestJson = {
  /**
   * @generated from field: string hr_manager_id = 1;
   */
  hrManagerId?: string;

  /**
   * @generated from field: string full_name = 2;
   */
  fullName?: string;

  /**
   * @generated from field: int32 max_expert_slots = 3;
   */
  maxExpertSlots?: number;

  /**
   * @generated from field: double commission_rate = 4;
   */
  commissionRate?: number | "NaN" | "Infinity" | "-Infinity";
};

/**
 * Describes the message guardianai.v1.hr.UpdateHrManagerRequest.
 * Use `create(UpdateHrManagerRequestSchema)` to create a new message.
 */
export const UpdateHrManagerRequestSchema: GenMessage<UpdateHrManagerRequest, {jsonType: UpdateHrManagerRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_hr_hr_manager, 6);

/**
 * @generated from message guardianai.v1.hr.DeleteHrManagerRequest
 */
export type DeleteHrManagerRequest = Message<"guardianai.v1.hr.DeleteHrManagerRequest"> & {
  /**
   * @generated from field: string hr_manager_id = 1;
   */
  hrManagerId: string;

  /**
   * @generated from field: string deleted_by_admin_id = 2;
   */
  deletedByAdminId: string;

  /**
   * @generated from field: string reason = 3;
   */
  reason: string;
};

/**
 * @generated from message guardianai.v1.hr.DeleteHrManagerRequest
 */
export type DeleteHrManagerRequestJson = {
  /**
   * @generated from field: string hr_manager_id = 1;
   */
  hrManagerId?: string;

  /**
   * @generated from field: string deleted_by_admin_id = 2;
   */
  deletedByAdminId?: string;

  /**
   * @generated from field: string reason = 3;
   */
  reason?: string;
};

/**
 * Describes the message guardianai.v1.hr.DeleteHrManagerRequest.
 * Use `create(DeleteHrManagerRequestSchema)` to create a new message.
 */
export const DeleteHrManagerRequestSchema: GenMessage<DeleteHrManagerRequest, {jsonType: DeleteHrManagerRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_hr_hr_manager, 7);

/**
 * @generated from message guardianai.v1.hr.DeleteHrManagerResponse
 */
export type DeleteHrManagerResponse = Message<"guardianai.v1.hr.DeleteHrManagerResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message: string;
};

/**
 * @generated from message guardianai.v1.hr.DeleteHrManagerResponse
 */
export type DeleteHrManagerResponseJson = {
  /**
   * @generated from field: bool success = 1;
   */
  success?: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message?: string;
};

/**
 * Describes the message guardianai.v1.hr.DeleteHrManagerResponse.
 * Use `create(DeleteHrManagerResponseSchema)` to create a new message.
 */
export const DeleteHrManagerResponseSchema: GenMessage<DeleteHrManagerResponse, {jsonType: DeleteHrManagerResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_hr_hr_manager, 8);

/**
 * @generated from message guardianai.v1.hr.GetSlotUsageRequest
 */
export type GetSlotUsageRequest = Message<"guardianai.v1.hr.GetSlotUsageRequest"> & {
  /**
   * @generated from field: string hr_manager_id = 1;
   */
  hrManagerId: string;
};

/**
 * @generated from message guardianai.v1.hr.GetSlotUsageRequest
 */
export type GetSlotUsageRequestJson = {
  /**
   * @generated from field: string hr_manager_id = 1;
   */
  hrManagerId?: string;
};

/**
 * Describes the message guardianai.v1.hr.GetSlotUsageRequest.
 * Use `create(GetSlotUsageRequestSchema)` to create a new message.
 */
export const GetSlotUsageRequestSchema: GenMessage<GetSlotUsageRequest, {jsonType: GetSlotUsageRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_hr_hr_manager, 9);

/**
 * @generated from message guardianai.v1.hr.SlotUsageResponse
 */
export type SlotUsageResponse = Message<"guardianai.v1.hr.SlotUsageResponse"> & {
  /**
   * @generated from field: string hr_manager_id = 1;
   */
  hrManagerId: string;

  /**
   * @generated from field: int32 max_slots = 2;
   */
  maxSlots: number;

  /**
   * @generated from field: int32 used_slots = 3;
   */
  usedSlots: number;

  /**
   * @generated from field: int32 available_slots = 4;
   */
  availableSlots: number;
};

/**
 * @generated from message guardianai.v1.hr.SlotUsageResponse
 */
export type SlotUsageResponseJson = {
  /**
   * @generated from field: string hr_manager_id = 1;
   */
  hrManagerId?: string;

  /**
   * @generated from field: int32 max_slots = 2;
   */
  maxSlots?: number;

  /**
   * @generated from field: int32 used_slots = 3;
   */
  usedSlots?: number;

  /**
   * @generated from field: int32 available_slots = 4;
   */
  availableSlots?: number;
};

/**
 * Describes the message guardianai.v1.hr.SlotUsageResponse.
 * Use `create(SlotUsageResponseSchema)` to create a new message.
 */
export const SlotUsageResponseSchema: GenMessage<SlotUsageResponse, {jsonType: SlotUsageResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_hr_hr_manager, 10);

/**
 * @generated from message guardianai.v1.hr.UpdateSlotLimitRequest
 */
export type UpdateSlotLimitRequest = Message<"guardianai.v1.hr.UpdateSlotLimitRequest"> & {
  /**
   * @generated from field: string hr_manager_id = 1;
   */
  hrManagerId: string;

  /**
   * @generated from field: int32 new_max_slots = 2;
   */
  newMaxSlots: number;

  /**
   * @generated from field: string updated_by_admin_id = 3;
   */
  updatedByAdminId: string;

  /**
   * @generated from field: string reason = 4;
   */
  reason: string;
};

/**
 * @generated from message guardianai.v1.hr.UpdateSlotLimitRequest
 */
export type UpdateSlotLimitRequestJson = {
  /**
   * @generated from field: string hr_manager_id = 1;
   */
  hrManagerId?: string;

  /**
   * @generated from field: int32 new_max_slots = 2;
   */
  newMaxSlots?: number;

  /**
   * @generated from field: string updated_by_admin_id = 3;
   */
  updatedByAdminId?: string;

  /**
   * @generated from field: string reason = 4;
   */
  reason?: string;
};

/**
 * Describes the message guardianai.v1.hr.UpdateSlotLimitRequest.
 * Use `create(UpdateSlotLimitRequestSchema)` to create a new message.
 */
export const UpdateSlotLimitRequestSchema: GenMessage<UpdateSlotLimitRequest, {jsonType: UpdateSlotLimitRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_hr_hr_manager, 11);

/**
 * @generated from message guardianai.v1.hr.CybersecurityExpert
 */
export type CybersecurityExpert = Message<"guardianai.v1.hr.CybersecurityExpert"> & {
  /**
   * @generated from field: string expert_id = 1;
   */
  expertId: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId: string;

  /**
   * @generated from field: string email = 3;
   */
  email: string;

  /**
   * @generated from field: string full_name = 4;
   */
  fullName: string;

  /**
   * PENDING, ACTIVE, SUSPENDED
   *
   * @generated from field: string status = 5;
   */
  status: string;

  /**
   * Who recruited this expert
   *
   * @generated from field: string hr_manager_id = 6;
   */
  hrManagerId: string;

  /**
   * pentest, cloud_audit, forensics, etc.
   *
   * @generated from field: repeated string skills = 7;
   */
  skills: string[];

  /**
   * OSCP, CEH, etc.
   *
   * @generated from field: repeated string certifications = 8;
   */
  certifications: string[];

  /**
   * Average rating from completed jobs
   *
   * @generated from field: double rating = 9;
   */
  rating: number;

  /**
   * @generated from field: int32 completed_jobs = 10;
   */
  completedJobs: number;

  /**
   * @generated from field: string suspended_by_user_id = 11;
   */
  suspendedByUserId: string;

  /**
   * HR_MANAGER or ADMIN
   *
   * @generated from field: string suspended_by_role = 12;
   */
  suspendedByRole: string;

  /**
   * @generated from field: string suspension_reason = 13;
   */
  suspensionReason: string;

  /**
   * @generated from field: int64 created_at = 14;
   */
  createdAt: bigint;

  /**
   * @generated from field: int64 updated_at = 15;
   */
  updatedAt: bigint;
};

/**
 * @generated from message guardianai.v1.hr.CybersecurityExpert
 */
export type CybersecurityExpertJson = {
  /**
   * @generated from field: string expert_id = 1;
   */
  expertId?: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId?: string;

  /**
   * @generated from field: string email = 3;
   */
  email?: string;

  /**
   * @generated from field: string full_name = 4;
   */
  fullName?: string;

  /**
   * PENDING, ACTIVE, SUSPENDED
   *
   * @generated from field: string status = 5;
   */
  status?: string;

  /**
   * Who recruited this expert
   *
   * @generated from field: string hr_manager_id = 6;
   */
  hrManagerId?: string;

  /**
   * pentest, cloud_audit, forensics, etc.
   *
   * @generated from field: repeated string skills = 7;
   */
  skills?: string[];

  /**
   * OSCP, CEH, etc.
   *
   * @generated from field: repeated string certifications = 8;
   */
  certifications?: string[];

  /**
   * Average rating from completed jobs
   *
   * @generated from field: double rating = 9;
   */
  rating?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: int32 completed_jobs = 10;
   */
  completedJobs?: number;

  /**
   * @generated from field: string suspended_by_user_id = 11;
   */
  suspendedByUserId?: string;

  /**
   * HR_MANAGER or ADMIN
   *
   * @generated from field: string suspended_by_role = 12;
   */
  suspendedByRole?: string;

  /**
   * @generated from field: string suspension_reason = 13;
   */
  suspensionReason?: string;

  /**
   * @generated from field: int64 created_at = 14;
   */
  createdAt?: string;

  /**
   * @generated from field: int64 updated_at = 15;
   */
  updatedAt?: string;
};

/**
 * Describes the message guardianai.v1.hr.CybersecurityExpert.
 * Use `create(CybersecurityExpertSchema)` to create a new message.
 */
export const CybersecurityExpertSchema: GenMessage<CybersecurityExpert, {jsonType: CybersecurityExpertJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_hr_hr_manager, 12);

/**
 * @generated from message guardianai.v1.hr.InviteExpertRequest
 */
export type InviteExpertRequest = Message<"guardianai.v1.hr.InviteExpertRequest"> & {
  /**
   * @generated from field: string hr_manager_id = 1;
   */
  hrManagerId: string;

  /**
   * @generated from field: string email = 2;
   */
  email: string;

  /**
   * @generated from field: string full_name = 3;
   */
  fullName: string;

  /**
   * @generated from field: repeated string initial_skills = 4;
   */
  initialSkills: string[];
};

/**
 * @generated from message guardianai.v1.hr.InviteExpertRequest
 */
export type InviteExpertRequestJson = {
  /**
   * @generated from field: string hr_manager_id = 1;
   */
  hrManagerId?: string;

  /**
   * @generated from field: string email = 2;
   */
  email?: string;

  /**
   * @generated from field: string full_name = 3;
   */
  fullName?: string;

  /**
   * @generated from field: repeated string initial_skills = 4;
   */
  initialSkills?: string[];
};

/**
 * Describes the message guardianai.v1.hr.InviteExpertRequest.
 * Use `create(InviteExpertRequestSchema)` to create a new message.
 */
export const InviteExpertRequestSchema: GenMessage<InviteExpertRequest, {jsonType: InviteExpertRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_hr_hr_manager, 13);

/**
 * @generated from message guardianai.v1.hr.InviteExpertResponse
 */
export type InviteExpertResponse = Message<"guardianai.v1.hr.InviteExpertResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message: string;

  /**
   * @generated from field: string pending_expert_id = 3;
   */
  pendingExpertId: string;

  /**
   * Sent via email (returned for testing)
   *
   * @generated from field: string magic_link_token = 4;
   */
  magicLinkToken: string;
};

/**
 * @generated from message guardianai.v1.hr.InviteExpertResponse
 */
export type InviteExpertResponseJson = {
  /**
   * @generated from field: bool success = 1;
   */
  success?: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message?: string;

  /**
   * @generated from field: string pending_expert_id = 3;
   */
  pendingExpertId?: string;

  /**
   * Sent via email (returned for testing)
   *
   * @generated from field: string magic_link_token = 4;
   */
  magicLinkToken?: string;
};

/**
 * Describes the message guardianai.v1.hr.InviteExpertResponse.
 * Use `create(InviteExpertResponseSchema)` to create a new message.
 */
export const InviteExpertResponseSchema: GenMessage<InviteExpertResponse, {jsonType: InviteExpertResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_hr_hr_manager, 14);

/**
 * @generated from message guardianai.v1.hr.ListMyExpertsRequest
 */
export type ListMyExpertsRequest = Message<"guardianai.v1.hr.ListMyExpertsRequest"> & {
  /**
   * @generated from field: string hr_manager_id = 1;
   */
  hrManagerId: string;

  /**
   * @generated from field: string status_filter = 2;
   */
  statusFilter: string;

  /**
   * @generated from field: int32 page = 3;
   */
  page: number;

  /**
   * @generated from field: int32 limit = 4;
   */
  limit: number;
};

/**
 * @generated from message guardianai.v1.hr.ListMyExpertsRequest
 */
export type ListMyExpertsRequestJson = {
  /**
   * @generated from field: string hr_manager_id = 1;
   */
  hrManagerId?: string;

  /**
   * @generated from field: string status_filter = 2;
   */
  statusFilter?: string;

  /**
   * @generated from field: int32 page = 3;
   */
  page?: number;

  /**
   * @generated from field: int32 limit = 4;
   */
  limit?: number;
};

/**
 * Describes the message guardianai.v1.hr.ListMyExpertsRequest.
 * Use `create(ListMyExpertsRequestSchema)` to create a new message.
 */
export const ListMyExpertsRequestSchema: GenMessage<ListMyExpertsRequest, {jsonType: ListMyExpertsRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_hr_hr_manager, 15);

/**
 * @generated from message guardianai.v1.hr.ListExpertsResponse
 */
export type ListExpertsResponse = Message<"guardianai.v1.hr.ListExpertsResponse"> & {
  /**
   * @generated from field: repeated guardianai.v1.hr.CybersecurityExpert experts = 1;
   */
  experts: CybersecurityExpert[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;

  /**
   * @generated from field: int32 page = 3;
   */
  page: number;

  /**
   * @generated from field: int32 limit = 4;
   */
  limit: number;
};

/**
 * @generated from message guardianai.v1.hr.ListExpertsResponse
 */
export type ListExpertsResponseJson = {
  /**
   * @generated from field: repeated guardianai.v1.hr.CybersecurityExpert experts = 1;
   */
  experts?: CybersecurityExpertJson[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount?: number;

  /**
   * @generated from field: int32 page = 3;
   */
  page?: number;

  /**
   * @generated from field: int32 limit = 4;
   */
  limit?: number;
};

/**
 * Describes the message guardianai.v1.hr.ListExpertsResponse.
 * Use `create(ListExpertsResponseSchema)` to create a new message.
 */
export const ListExpertsResponseSchema: GenMessage<ListExpertsResponse, {jsonType: ListExpertsResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_hr_hr_manager, 16);

/**
 * @generated from message guardianai.v1.hr.GetExpertRequest
 */
export type GetExpertRequest = Message<"guardianai.v1.hr.GetExpertRequest"> & {
  /**
   * @generated from field: string expert_id = 1;
   */
  expertId: string;
};

/**
 * @generated from message guardianai.v1.hr.GetExpertRequest
 */
export type GetExpertRequestJson = {
  /**
   * @generated from field: string expert_id = 1;
   */
  expertId?: string;
};

/**
 * Describes the message guardianai.v1.hr.GetExpertRequest.
 * Use `create(GetExpertRequestSchema)` to create a new message.
 */
export const GetExpertRequestSchema: GenMessage<GetExpertRequest, {jsonType: GetExpertRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_hr_hr_manager, 17);

/**
 * @generated from message guardianai.v1.hr.ExpertResponse
 */
export type ExpertResponse = Message<"guardianai.v1.hr.ExpertResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message: string;

  /**
   * @generated from field: guardianai.v1.hr.CybersecurityExpert expert = 3;
   */
  expert?: CybersecurityExpert;
};

/**
 * @generated from message guardianai.v1.hr.ExpertResponse
 */
export type ExpertResponseJson = {
  /**
   * @generated from field: bool success = 1;
   */
  success?: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message?: string;

  /**
   * @generated from field: guardianai.v1.hr.CybersecurityExpert expert = 3;
   */
  expert?: CybersecurityExpertJson;
};

/**
 * Describes the message guardianai.v1.hr.ExpertResponse.
 * Use `create(ExpertResponseSchema)` to create a new message.
 */
export const ExpertResponseSchema: GenMessage<ExpertResponse, {jsonType: ExpertResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_hr_hr_manager, 18);

/**
 * @generated from message guardianai.v1.hr.SuspendExpertRequest
 */
export type SuspendExpertRequest = Message<"guardianai.v1.hr.SuspendExpertRequest"> & {
  /**
   * @generated from field: string expert_id = 1;
   */
  expertId: string;

  /**
   * @generated from field: string suspended_by_user_id = 2;
   */
  suspendedByUserId: string;

  /**
   * HR_MANAGER or ADMIN
   *
   * @generated from field: string suspended_by_role = 3;
   */
  suspendedByRole: string;

  /**
   * @generated from field: string reason = 4;
   */
  reason: string;
};

/**
 * @generated from message guardianai.v1.hr.SuspendExpertRequest
 */
export type SuspendExpertRequestJson = {
  /**
   * @generated from field: string expert_id = 1;
   */
  expertId?: string;

  /**
   * @generated from field: string suspended_by_user_id = 2;
   */
  suspendedByUserId?: string;

  /**
   * HR_MANAGER or ADMIN
   *
   * @generated from field: string suspended_by_role = 3;
   */
  suspendedByRole?: string;

  /**
   * @generated from field: string reason = 4;
   */
  reason?: string;
};

/**
 * Describes the message guardianai.v1.hr.SuspendExpertRequest.
 * Use `create(SuspendExpertRequestSchema)` to create a new message.
 */
export const SuspendExpertRequestSchema: GenMessage<SuspendExpertRequest, {jsonType: SuspendExpertRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_hr_hr_manager, 19);

/**
 * @generated from message guardianai.v1.hr.SuspendExpertResponse
 */
export type SuspendExpertResponse = Message<"guardianai.v1.hr.SuspendExpertResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message: string;

  /**
   * @generated from field: guardianai.v1.hr.CybersecurityExpert expert = 3;
   */
  expert?: CybersecurityExpert;
};

/**
 * @generated from message guardianai.v1.hr.SuspendExpertResponse
 */
export type SuspendExpertResponseJson = {
  /**
   * @generated from field: bool success = 1;
   */
  success?: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message?: string;

  /**
   * @generated from field: guardianai.v1.hr.CybersecurityExpert expert = 3;
   */
  expert?: CybersecurityExpertJson;
};

/**
 * Describes the message guardianai.v1.hr.SuspendExpertResponse.
 * Use `create(SuspendExpertResponseSchema)` to create a new message.
 */
export const SuspendExpertResponseSchema: GenMessage<SuspendExpertResponse, {jsonType: SuspendExpertResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_hr_hr_manager, 20);

/**
 * @generated from message guardianai.v1.hr.UnsuspendExpertRequest
 */
export type UnsuspendExpertRequest = Message<"guardianai.v1.hr.UnsuspendExpertRequest"> & {
  /**
   * @generated from field: string expert_id = 1;
   */
  expertId: string;

  /**
   * @generated from field: string unsuspended_by_user_id = 2;
   */
  unsuspendedByUserId: string;

  /**
   * @generated from field: string unsuspended_by_role = 3;
   */
  unsuspendedByRole: string;
};

/**
 * @generated from message guardianai.v1.hr.UnsuspendExpertRequest
 */
export type UnsuspendExpertRequestJson = {
  /**
   * @generated from field: string expert_id = 1;
   */
  expertId?: string;

  /**
   * @generated from field: string unsuspended_by_user_id = 2;
   */
  unsuspendedByUserId?: string;

  /**
   * @generated from field: string unsuspended_by_role = 3;
   */
  unsuspendedByRole?: string;
};

/**
 * Describes the message guardianai.v1.hr.UnsuspendExpertRequest.
 * Use `create(UnsuspendExpertRequestSchema)` to create a new message.
 */
export const UnsuspendExpertRequestSchema: GenMessage<UnsuspendExpertRequest, {jsonType: UnsuspendExpertRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_hr_hr_manager, 21);

/**
 * @generated from message guardianai.v1.hr.UnsuspendExpertResponse
 */
export type UnsuspendExpertResponse = Message<"guardianai.v1.hr.UnsuspendExpertResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message: string;

  /**
   * AUTHORITY_TOO_LOW if HR trying to unsuspend admin-suspended
   *
   * @generated from field: string error_code = 3;
   */
  errorCode: string;

  /**
   * @generated from field: guardianai.v1.hr.CybersecurityExpert expert = 4;
   */
  expert?: CybersecurityExpert;
};

/**
 * @generated from message guardianai.v1.hr.UnsuspendExpertResponse
 */
export type UnsuspendExpertResponseJson = {
  /**
   * @generated from field: bool success = 1;
   */
  success?: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message?: string;

  /**
   * AUTHORITY_TOO_LOW if HR trying to unsuspend admin-suspended
   *
   * @generated from field: string error_code = 3;
   */
  errorCode?: string;

  /**
   * @generated from field: guardianai.v1.hr.CybersecurityExpert expert = 4;
   */
  expert?: CybersecurityExpertJson;
};

/**
 * Describes the message guardianai.v1.hr.UnsuspendExpertResponse.
 * Use `create(UnsuspendExpertResponseSchema)` to create a new message.
 */
export const UnsuspendExpertResponseSchema: GenMessage<UnsuspendExpertResponse, {jsonType: UnsuspendExpertResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_hr_hr_manager, 22);

/**
 * @generated from message guardianai.v1.hr.GetEarningsBreakdownRequest
 */
export type GetEarningsBreakdownRequest = Message<"guardianai.v1.hr.GetEarningsBreakdownRequest"> & {
  /**
   * @generated from field: string hr_manager_id = 1;
   */
  hrManagerId: string;

  /**
   * Unix timestamp
   *
   * @generated from field: int64 from_date = 2;
   */
  fromDate: bigint;

  /**
   * @generated from field: int64 to_date = 3;
   */
  toDate: bigint;
};

/**
 * @generated from message guardianai.v1.hr.GetEarningsBreakdownRequest
 */
export type GetEarningsBreakdownRequestJson = {
  /**
   * @generated from field: string hr_manager_id = 1;
   */
  hrManagerId?: string;

  /**
   * Unix timestamp
   *
   * @generated from field: int64 from_date = 2;
   */
  fromDate?: string;

  /**
   * @generated from field: int64 to_date = 3;
   */
  toDate?: string;
};

/**
 * Describes the message guardianai.v1.hr.GetEarningsBreakdownRequest.
 * Use `create(GetEarningsBreakdownRequestSchema)` to create a new message.
 */
export const GetEarningsBreakdownRequestSchema: GenMessage<GetEarningsBreakdownRequest, {jsonType: GetEarningsBreakdownRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_hr_hr_manager, 23);

/**
 * @generated from message guardianai.v1.hr.HrEarningsBreakdownResponse
 */
export type HrEarningsBreakdownResponse = Message<"guardianai.v1.hr.HrEarningsBreakdownResponse"> & {
  /**
   * @generated from field: string hr_manager_id = 1;
   */
  hrManagerId: string;

  /**
   * @generated from field: int64 total_earnings_cents = 2;
   */
  totalEarningsCents: bigint;

  /**
   * @generated from field: int64 platform_commission_cents = 3;
   */
  platformCommissionCents: bigint;

  /**
   * @generated from field: int64 net_earnings_cents = 4;
   */
  netEarningsCents: bigint;

  /**
   * @generated from field: repeated guardianai.v1.hr.ExpertContribution by_expert = 5;
   */
  byExpert: ExpertContribution[];
};

/**
 * @generated from message guardianai.v1.hr.HrEarningsBreakdownResponse
 */
export type HrEarningsBreakdownResponseJson = {
  /**
   * @generated from field: string hr_manager_id = 1;
   */
  hrManagerId?: string;

  /**
   * @generated from field: int64 total_earnings_cents = 2;
   */
  totalEarningsCents?: string;

  /**
   * @generated from field: int64 platform_commission_cents = 3;
   */
  platformCommissionCents?: string;

  /**
   * @generated from field: int64 net_earnings_cents = 4;
   */
  netEarningsCents?: string;

  /**
   * @generated from field: repeated guardianai.v1.hr.ExpertContribution by_expert = 5;
   */
  byExpert?: ExpertContributionJson[];
};

/**
 * Describes the message guardianai.v1.hr.HrEarningsBreakdownResponse.
 * Use `create(HrEarningsBreakdownResponseSchema)` to create a new message.
 */
export const HrEarningsBreakdownResponseSchema: GenMessage<HrEarningsBreakdownResponse, {jsonType: HrEarningsBreakdownResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_hr_hr_manager, 24);

/**
 * @generated from message guardianai.v1.hr.ExpertContribution
 */
export type ExpertContribution = Message<"guardianai.v1.hr.ExpertContribution"> & {
  /**
   * @generated from field: string expert_id = 1;
   */
  expertId: string;

  /**
   * @generated from field: string expert_name = 2;
   */
  expertName: string;

  /**
   * @generated from field: int64 jobs_completed = 3;
   */
  jobsCompleted: bigint;

  /**
   * @generated from field: int64 gross_earnings_cents = 4;
   */
  grossEarningsCents: bigint;

  /**
   * @generated from field: int64 hr_commission_cents = 5;
   */
  hrCommissionCents: bigint;
};

/**
 * @generated from message guardianai.v1.hr.ExpertContribution
 */
export type ExpertContributionJson = {
  /**
   * @generated from field: string expert_id = 1;
   */
  expertId?: string;

  /**
   * @generated from field: string expert_name = 2;
   */
  expertName?: string;

  /**
   * @generated from field: int64 jobs_completed = 3;
   */
  jobsCompleted?: string;

  /**
   * @generated from field: int64 gross_earnings_cents = 4;
   */
  grossEarningsCents?: string;

  /**
   * @generated from field: int64 hr_commission_cents = 5;
   */
  hrCommissionCents?: string;
};

/**
 * Describes the message guardianai.v1.hr.ExpertContribution.
 * Use `create(ExpertContributionSchema)` to create a new message.
 */
export const ExpertContributionSchema: GenMessage<ExpertContribution, {jsonType: ExpertContributionJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_hr_hr_manager, 25);

/**
 * @generated from message guardianai.v1.hr.GetCommissionRateRequest
 */
export type GetCommissionRateRequest = Message<"guardianai.v1.hr.GetCommissionRateRequest"> & {
  /**
   * @generated from field: string hr_manager_id = 1;
   */
  hrManagerId: string;
};

/**
 * @generated from message guardianai.v1.hr.GetCommissionRateRequest
 */
export type GetCommissionRateRequestJson = {
  /**
   * @generated from field: string hr_manager_id = 1;
   */
  hrManagerId?: string;
};

/**
 * Describes the message guardianai.v1.hr.GetCommissionRateRequest.
 * Use `create(GetCommissionRateRequestSchema)` to create a new message.
 */
export const GetCommissionRateRequestSchema: GenMessage<GetCommissionRateRequest, {jsonType: GetCommissionRateRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_hr_hr_manager, 26);

/**
 * @generated from message guardianai.v1.hr.CommissionRateResponse
 */
export type CommissionRateResponse = Message<"guardianai.v1.hr.CommissionRateResponse"> & {
  /**
   * @generated from field: string hr_manager_id = 1;
   */
  hrManagerId: string;

  /**
   * @generated from field: double commission_rate = 2;
   */
  commissionRate: number;

  /**
   * For transparency
   *
   * @generated from field: double platform_rate = 3;
   */
  platformRate: number;
};

/**
 * @generated from message guardianai.v1.hr.CommissionRateResponse
 */
export type CommissionRateResponseJson = {
  /**
   * @generated from field: string hr_manager_id = 1;
   */
  hrManagerId?: string;

  /**
   * @generated from field: double commission_rate = 2;
   */
  commissionRate?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * For transparency
   *
   * @generated from field: double platform_rate = 3;
   */
  platformRate?: number | "NaN" | "Infinity" | "-Infinity";
};

/**
 * Describes the message guardianai.v1.hr.CommissionRateResponse.
 * Use `create(CommissionRateResponseSchema)` to create a new message.
 */
export const CommissionRateResponseSchema: GenMessage<CommissionRateResponse, {jsonType: CommissionRateResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_hr_hr_manager, 27);

/**
 * @generated from message guardianai.v1.hr.GenerateMagicLinkRequest
 */
export type GenerateMagicLinkRequest = Message<"guardianai.v1.hr.GenerateMagicLinkRequest"> & {
  /**
   * @generated from field: string email = 1;
   */
  email: string;

  /**
   * HR_MANAGER or CYBERSECURITY_EXPERT
   *
   * @generated from field: string role = 2;
   */
  role: string;

  /**
   * @generated from field: string invited_by_user_id = 3;
   */
  invitedByUserId: string;

  /**
   * Default: 72
   *
   * @generated from field: int64 expires_in_hours = 4;
   */
  expiresInHours: bigint;

  /**
   * hr_manager_id for experts, etc.
   *
   * @generated from field: map<string, string> metadata = 5;
   */
  metadata: { [key: string]: string };
};

/**
 * @generated from message guardianai.v1.hr.GenerateMagicLinkRequest
 */
export type GenerateMagicLinkRequestJson = {
  /**
   * @generated from field: string email = 1;
   */
  email?: string;

  /**
   * HR_MANAGER or CYBERSECURITY_EXPERT
   *
   * @generated from field: string role = 2;
   */
  role?: string;

  /**
   * @generated from field: string invited_by_user_id = 3;
   */
  invitedByUserId?: string;

  /**
   * Default: 72
   *
   * @generated from field: int64 expires_in_hours = 4;
   */
  expiresInHours?: string;

  /**
   * hr_manager_id for experts, etc.
   *
   * @generated from field: map<string, string> metadata = 5;
   */
  metadata?: { [key: string]: string };
};

/**
 * Describes the message guardianai.v1.hr.GenerateMagicLinkRequest.
 * Use `create(GenerateMagicLinkRequestSchema)` to create a new message.
 */
export const GenerateMagicLinkRequestSchema: GenMessage<GenerateMagicLinkRequest, {jsonType: GenerateMagicLinkRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_hr_hr_manager, 28);

/**
 * @generated from message guardianai.v1.hr.MagicLinkResponse
 */
export type MagicLinkResponse = Message<"guardianai.v1.hr.MagicLinkResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message: string;

  /**
   * @generated from field: string magic_link_url = 3;
   */
  magicLinkUrl: string;

  /**
   * @generated from field: int64 expires_at = 4;
   */
  expiresAt: bigint;
};

/**
 * @generated from message guardianai.v1.hr.MagicLinkResponse
 */
export type MagicLinkResponseJson = {
  /**
   * @generated from field: bool success = 1;
   */
  success?: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message?: string;

  /**
   * @generated from field: string magic_link_url = 3;
   */
  magicLinkUrl?: string;

  /**
   * @generated from field: int64 expires_at = 4;
   */
  expiresAt?: string;
};

/**
 * Describes the message guardianai.v1.hr.MagicLinkResponse.
 * Use `create(MagicLinkResponseSchema)` to create a new message.
 */
export const MagicLinkResponseSchema: GenMessage<MagicLinkResponse, {jsonType: MagicLinkResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_hr_hr_manager, 29);

/**
 * @generated from message guardianai.v1.hr.ValidateMagicLinkRequest
 */
export type ValidateMagicLinkRequest = Message<"guardianai.v1.hr.ValidateMagicLinkRequest"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;
};

/**
 * @generated from message guardianai.v1.hr.ValidateMagicLinkRequest
 */
export type ValidateMagicLinkRequestJson = {
  /**
   * @generated from field: string token = 1;
   */
  token?: string;
};

/**
 * Describes the message guardianai.v1.hr.ValidateMagicLinkRequest.
 * Use `create(ValidateMagicLinkRequestSchema)` to create a new message.
 */
export const ValidateMagicLinkRequestSchema: GenMessage<ValidateMagicLinkRequest, {jsonType: ValidateMagicLinkRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_hr_hr_manager, 30);

/**
 * @generated from message guardianai.v1.hr.ValidateMagicLinkResponse
 */
export type ValidateMagicLinkResponse = Message<"guardianai.v1.hr.ValidateMagicLinkResponse"> & {
  /**
   * @generated from field: bool valid = 1;
   */
  valid: boolean;

  /**
   * @generated from field: string email = 2;
   */
  email: string;

  /**
   * @generated from field: string role = 3;
   */
  role: string;

  /**
   * @generated from field: string pending_user_id = 4;
   */
  pendingUserId: string;

  /**
   * "Invited by John Doe"
   *
   * @generated from field: string invited_by_name = 5;
   */
  invitedByName: string;

  /**
   * For experts: who recruited them
   *
   * @generated from field: string hr_manager_name = 6;
   */
  hrManagerName: string;

  /**
   * EXPIRED, INVALID, ALREADY_USED
   *
   * @generated from field: string error_code = 7;
   */
  errorCode: string;
};

/**
 * @generated from message guardianai.v1.hr.ValidateMagicLinkResponse
 */
export type ValidateMagicLinkResponseJson = {
  /**
   * @generated from field: bool valid = 1;
   */
  valid?: boolean;

  /**
   * @generated from field: string email = 2;
   */
  email?: string;

  /**
   * @generated from field: string role = 3;
   */
  role?: string;

  /**
   * @generated from field: string pending_user_id = 4;
   */
  pendingUserId?: string;

  /**
   * "Invited by John Doe"
   *
   * @generated from field: string invited_by_name = 5;
   */
  invitedByName?: string;

  /**
   * For experts: who recruited them
   *
   * @generated from field: string hr_manager_name = 6;
   */
  hrManagerName?: string;

  /**
   * EXPIRED, INVALID, ALREADY_USED
   *
   * @generated from field: string error_code = 7;
   */
  errorCode?: string;
};

/**
 * Describes the message guardianai.v1.hr.ValidateMagicLinkResponse.
 * Use `create(ValidateMagicLinkResponseSchema)` to create a new message.
 */
export const ValidateMagicLinkResponseSchema: GenMessage<ValidateMagicLinkResponse, {jsonType: ValidateMagicLinkResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_hr_hr_manager, 31);

/**
 * @generated from message guardianai.v1.hr.CompleteOnboardingRequest
 */
export type CompleteOnboardingRequest = Message<"guardianai.v1.hr.CompleteOnboardingRequest"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * @generated from field: string password = 2;
   */
  password: string;

  /**
   * @generated from field: string full_name = 3;
   */
  fullName: string;

  /**
   * For experts
   *
   * @generated from field: repeated string skills = 4;
   */
  skills: string[];

  /**
   * @generated from field: string timezone = 5;
   */
  timezone: string;
};

/**
 * @generated from message guardianai.v1.hr.CompleteOnboardingRequest
 */
export type CompleteOnboardingRequestJson = {
  /**
   * @generated from field: string token = 1;
   */
  token?: string;

  /**
   * @generated from field: string password = 2;
   */
  password?: string;

  /**
   * @generated from field: string full_name = 3;
   */
  fullName?: string;

  /**
   * For experts
   *
   * @generated from field: repeated string skills = 4;
   */
  skills?: string[];

  /**
   * @generated from field: string timezone = 5;
   */
  timezone?: string;
};

/**
 * Describes the message guardianai.v1.hr.CompleteOnboardingRequest.
 * Use `create(CompleteOnboardingRequestSchema)` to create a new message.
 */
export const CompleteOnboardingRequestSchema: GenMessage<CompleteOnboardingRequest, {jsonType: CompleteOnboardingRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_hr_hr_manager, 32);

/**
 * @generated from message guardianai.v1.hr.CompleteOnboardingResponse
 */
export type CompleteOnboardingResponse = Message<"guardianai.v1.hr.CompleteOnboardingResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message: string;

  /**
   * @generated from field: string access_token = 3;
   */
  accessToken: string;

  /**
   * @generated from field: string refresh_token = 4;
   */
  refreshToken: string;

  /**
   * @generated from field: string user_id = 5;
   */
  userId: string;

  /**
   * @generated from field: string role = 6;
   */
  role: string;
};

/**
 * @generated from message guardianai.v1.hr.CompleteOnboardingResponse
 */
export type CompleteOnboardingResponseJson = {
  /**
   * @generated from field: bool success = 1;
   */
  success?: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message?: string;

  /**
   * @generated from field: string access_token = 3;
   */
  accessToken?: string;

  /**
   * @generated from field: string refresh_token = 4;
   */
  refreshToken?: string;

  /**
   * @generated from field: string user_id = 5;
   */
  userId?: string;

  /**
   * @generated from field: string role = 6;
   */
  role?: string;
};

/**
 * Describes the message guardianai.v1.hr.CompleteOnboardingResponse.
 * Use `create(CompleteOnboardingResponseSchema)` to create a new message.
 */
export const CompleteOnboardingResponseSchema: GenMessage<CompleteOnboardingResponse, {jsonType: CompleteOnboardingResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_hr_hr_manager, 33);

/**
 * @generated from message guardianai.v1.hr.ResendMagicLinkRequest
 */
export type ResendMagicLinkRequest = Message<"guardianai.v1.hr.ResendMagicLinkRequest"> & {
  /**
   * @generated from field: string email = 1;
   */
  email: string;
};

/**
 * @generated from message guardianai.v1.hr.ResendMagicLinkRequest
 */
export type ResendMagicLinkRequestJson = {
  /**
   * @generated from field: string email = 1;
   */
  email?: string;
};

/**
 * Describes the message guardianai.v1.hr.ResendMagicLinkRequest.
 * Use `create(ResendMagicLinkRequestSchema)` to create a new message.
 */
export const ResendMagicLinkRequestSchema: GenMessage<ResendMagicLinkRequest, {jsonType: ResendMagicLinkRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_hr_hr_manager, 34);

/**
 * @generated from service guardianai.v1.hr.HrManagerService
 */
export const HrManagerService: GenService<{
  /**
   * HR Manager CRUD (Admin only)
   *
   * @generated from rpc guardianai.v1.hr.HrManagerService.CreateHrManager
   */
  createHrManager: {
    methodKind: "unary";
    input: typeof CreateHrManagerRequestSchema;
    output: typeof HrManagerResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.hr.HrManagerService.GetHrManager
   */
  getHrManager: {
    methodKind: "unary";
    input: typeof GetHrManagerRequestSchema;
    output: typeof HrManagerResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.hr.HrManagerService.ListHrManagers
   */
  listHrManagers: {
    methodKind: "unary";
    input: typeof ListHrManagersRequestSchema;
    output: typeof ListHrManagersResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.hr.HrManagerService.UpdateHrManager
   */
  updateHrManager: {
    methodKind: "unary";
    input: typeof UpdateHrManagerRequestSchema;
    output: typeof HrManagerResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.hr.HrManagerService.DeleteHrManager
   */
  deleteHrManager: {
    methodKind: "unary";
    input: typeof DeleteHrManagerRequestSchema;
    output: typeof DeleteHrManagerResponseSchema;
  },
  /**
   * Expert Slot Management
   *
   * @generated from rpc guardianai.v1.hr.HrManagerService.GetSlotUsage
   */
  getSlotUsage: {
    methodKind: "unary";
    input: typeof GetSlotUsageRequestSchema;
    output: typeof SlotUsageResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.hr.HrManagerService.UpdateSlotLimit
   */
  updateSlotLimit: {
    methodKind: "unary";
    input: typeof UpdateSlotLimitRequestSchema;
    output: typeof SlotUsageResponseSchema;
  },
  /**
   * Expert Recruitment (HR Manager)
   *
   * @generated from rpc guardianai.v1.hr.HrManagerService.InviteExpert
   */
  inviteExpert: {
    methodKind: "unary";
    input: typeof InviteExpertRequestSchema;
    output: typeof InviteExpertResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.hr.HrManagerService.ListMyExperts
   */
  listMyExperts: {
    methodKind: "unary";
    input: typeof ListMyExpertsRequestSchema;
    output: typeof ListExpertsResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.hr.HrManagerService.GetExpert
   */
  getExpert: {
    methodKind: "unary";
    input: typeof GetExpertRequestSchema;
    output: typeof ExpertResponseSchema;
  },
  /**
   * Suspension (HR Manager can suspend their experts)
   *
   * @generated from rpc guardianai.v1.hr.HrManagerService.SuspendExpert
   */
  suspendExpert: {
    methodKind: "unary";
    input: typeof SuspendExpertRequestSchema;
    output: typeof SuspendExpertResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.hr.HrManagerService.UnsuspendExpert
   */
  unsuspendExpert: {
    methodKind: "unary";
    input: typeof UnsuspendExpertRequestSchema;
    output: typeof UnsuspendExpertResponseSchema;
  },
  /**
   * Commission & Earnings
   *
   * @generated from rpc guardianai.v1.hr.HrManagerService.GetEarningsBreakdown
   */
  getEarningsBreakdown: {
    methodKind: "unary";
    input: typeof GetEarningsBreakdownRequestSchema;
    output: typeof HrEarningsBreakdownResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.hr.HrManagerService.GetCommissionRate
   */
  getCommissionRate: {
    methodKind: "unary";
    input: typeof GetCommissionRateRequestSchema;
    output: typeof CommissionRateResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_guardianai_v1_hr_hr_manager, 0);

/**
 * @generated from service guardianai.v1.hr.MagicLinkService
 */
export const MagicLinkService: GenService<{
  /**
   * Generate magic link for HR Manager or Expert invite
   *
   * @generated from rpc guardianai.v1.hr.MagicLinkService.GenerateMagicLink
   */
  generateMagicLink: {
    methodKind: "unary";
    input: typeof GenerateMagicLinkRequestSchema;
    output: typeof MagicLinkResponseSchema;
  },
  /**
   * Validate magic link token
   *
   * @generated from rpc guardianai.v1.hr.MagicLinkService.ValidateMagicLink
   */
  validateMagicLink: {
    methodKind: "unary";
    input: typeof ValidateMagicLinkRequestSchema;
    output: typeof ValidateMagicLinkResponseSchema;
  },
  /**
   * Complete onboarding after clicking magic link
   *
   * @generated from rpc guardianai.v1.hr.MagicLinkService.CompleteOnboarding
   */
  completeOnboarding: {
    methodKind: "unary";
    input: typeof CompleteOnboardingRequestSchema;
    output: typeof CompleteOnboardingResponseSchema;
  },
  /**
   * Resend magic link (if expired)
   *
   * @generated from rpc guardianai.v1.hr.MagicLinkService.ResendMagicLink
   */
  resendMagicLink: {
    methodKind: "unary";
    input: typeof ResendMagicLinkRequestSchema;
    output: typeof MagicLinkResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_guardianai_v1_hr_hr_manager, 1);

